import React from 'react';

import PropTypes from 'prop-types';

import { useBrand } from '@atc/brand';

import { Text } from 'reaxl';

import MoneyBackGuaranteeModal from '@/components/vehicledetails/MoneyBackGuaranteeModal';

import Card from './Card';
import CardContentWithAnalytics from './CardContentWithAnalytics';
import { getMoneyBackGuaranteeContent } from './dynamicContent';
import { cardHeaders, cardImages } from './staticContent';

function MoneyBackGuaranteeCard({
    returnPolicy,
    setModalDetail,
    handleSeeDetailsClick = () => { },
    handleContentImpression = () => { },
    listingId,
    isInverse,
    ...rest
}) {
    const { brands, isBrand } = useBrand();
    const isAtc = isBrand(brands.ATC_BRAND);

    return (
        <Card
            id="mbg"
            heading={cardHeaders.MONEY_BACK_GUARANTEE}
            image={isAtc ? cardImages.MONEY_BACK_GUARANTEE_ATC : cardImages.MONEY_BACK_GUARANTEE}
            showTile
            isInverse={isInverse}
            {...rest}
        >
            <CardContentWithAnalytics
                cardType="Peace of Mind"
                handleContentImpression={handleContentImpression}
                listingId={listingId}
            >
                <Text
                    componentClass="p"
                    className="margin-bottom-2"
                >
                    {getMoneyBackGuaranteeContent(returnPolicy)}
                </Text>
                <MoneyBackGuaranteeModal buttonStyle={isInverse ? 'text-decorated-inverse' : 'text-decorated'} />
            </CardContentWithAnalytics>
        </Card>
    );
}

MoneyBackGuaranteeCard.propTypes = {
    isInverse: PropTypes.bool,
};

export default MoneyBackGuaranteeCard;
